module.exports = __webpack_public_path__ + "img/2095d43.png";